import { Capacitor } from '@capacitor/core';

import type { AuthService } from 'ionic-appauth';

import Config from 'Config';
import { OktaAuthBase } from './OktaAuthService';

export class OktaExternalAuth extends OktaAuthBase {
    private static authService: Promise<AuthService> | undefined;

    protected static async buildAuthInstance() {
        const platform = Capacitor.getPlatform();
        const isMobileApp = platform === 'ios' || platform === 'android';

        return super.buildAuthInstance({
            config: {
                oktaClientId: isMobileApp ? Config.oktaMobileExternalClientId : Config.oktaExternalClientId,
                oktaServerHostUrl: `${Config.oktaExternalServerHostUrl}/oauth2/default`,
                oktaSignInRedirectPath: Config.oktaExternalSignInRedirectPath,
                oktaSignOutRedirectPath: Config.oktaExternalSignOutRedirectPath,
            },
        });
    }

    public static getInstance() {
        /* eslint-disable-next-line no-return-assign -- we actually do want to both assign and return the result here */
        return this.authService ?? (this.authService = this.buildAuthInstance());
    }
}
